import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './base';
import { axiosBaseNotificationQuery } from './base/notification';
import { axiosPublicBaseQuery } from './base/public';
import { axiosCareerPortalQuery } from './base/career-portal';
import { axiosAtsQuery } from './base/ats';
import { axiosAgentforgeQuery } from './base/agentforge';

export const apiQuery = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'GetOutreachCandidates',
    'GetCandidates',
    'GetOutreaches',
    'GetContacts',
    'GetTasksSnapshots',
    'GetTasks',
    'GetTemplates',
    'GetChannelSettings',
    'GetProjectsInternalUsers',
    'GetProjectsExternalUsers',
    'GetOrgRoles',
    'GetOrgRoleById',
    'GetAllUsers',
    'GetUserById',
    'GetAllContacts',
    'GetContactById',
    'GetJobBoardsIntegrations',
    'GetMeProfile',
    'Contact',
    'GetAtsContactsResume',
  ],
  reducerPath: 'apiQuery',
  endpoints: () => ({}),
});

export const notificationApiQuery = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: axiosBaseNotificationQuery(),
  tagTypes: ['GetNotifications'],
  reducerPath: 'notificationApiQuery',
  endpoints: () => ({}),
});

export const publicApiQuery = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: axiosPublicBaseQuery(),
  reducerPath: 'publicApiQuery',
  endpoints: () => ({}),
});

export const careerPortalApiQuery = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: axiosCareerPortalQuery(),
  reducerPath: 'careerPortalApiQuery',
  tagTypes: ['GetThemes', 'GetSettings', 'GetThemeById'],
  endpoints: () => ({}),
});

export const agentforgeApiQuery = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: axiosAgentforgeQuery(),
  reducerPath: 'agentforgeApiQuery',
  tagTypes: [
    'MCDashboard',
    'MCActivities',
    'MCDelegations',
    'MCAgents',
    'MCSessions',
    'MCMessages',
    'AFKnowledge',
    'AFSkills',
    'AFFeedback',
    'AFChannels',
  ],
  endpoints: () => ({}),
});

export const atsApiQuery = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: axiosAtsQuery(),
  reducerPath: 'atsApiQuery',
  tagTypes: [
    'GetInterviewPools',
    'GetAtsDepartments',
    'GetAtsCloseJobReasons',
    'GetAtsOffices',
    'GetAtsRejectReasons',
    'GetCandidateSources',
    'GetApprovalsList',
    'GetApprovalById',
    'GetApprovalsSettings',
    'GetEeoSettings',
    'GetNoteTakerSettings',
    'GetCompensationSettings',
    'GetCompensationCurrencies',
    'GetAllCustomFields',
    'GetScoreCards',
    'getApprovalsByEntity',
    'GetEmailTemplatesSettingsList',
    'GetInterviewPlans',
    'GetInterviewPlanById',
    'GetScoreCardById',
    'GetTemplatesCategories',
    'GetTemplateById',
    'GetAllOfferTemplates',
    'GetOfferTemplateById',
    'GetSupportedOfferTokens',
    'GetInterviewById',
    'GetAtsContactsResume',
    'GetTemplatesVariables',
    'GetNewAppForm',
    'GetAllAppForms',
    'GetJobAppForm',
    'GetReferralSettingsPolicy',
    'GetReferralSettingsForm',
    'GetReferralSettingsEmailTemplates',
    'GetCurrentJobBoards',
    'GetOfferById',
    'getReferredList',
    'getReferredById',
    'GetReferralsJob',
    'GetJobReferralLink',
    'GetAllJobsReferrals',
    'GetOfferById',
    'GetScoreCardForInterview',
    'GetAllScheduleReports',
    'GetScheduleReportById',
    'ReviewDetails',
  ],
  endpoints: () => ({}),
});
